import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {Alert, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, TextField} from "@mui/material";
import {ROLES} from "../../util/Const";
import Button from "@mui/material/Button";
import React, {useState} from "react";
import userService from "../../services/UserService";
import {useSnackbar} from "../../util/SnackbarProvider";

const Profile = () => {

    const user = JSON.parse(localStorage.getItem("user"));
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => setOpen(true);
    const {sendAlertMessage} = useSnackbar()
    const [errorMessage, setErrorMessage] = useState();
    const [waitingForServer, setWaitingForServer] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setErrorMessage(undefined);
    }

    let firstColumnStyle = {fontWeight: "bold", paddingRight: "20px"};

    const updatePassword = (oldPassword, newPassword, newPasswordDoubleCheck) => {
        if (newPassword !== newPasswordDoubleCheck) {
            setErrorMessage('A jelszavak nem egyeznek')
            return
        }
        setWaitingForServer(true);
        userService.updatePassword({oldPassword, newPassword})
            .then(() => {
                sendAlertMessage("Jelszó változtatás sikeres")
                handleClose()
            })
            .catch(error => sendAlertMessage(error?.message || "Jelszó változtatás sikertelen", 'error'))
            .finally(() => setWaitingForServer(false))
    }

    return (
        <>
            <Paper sx={{padding: "10px"}}>
                <Typography variant="h4" component="div" textAlign="center">
                    Profil
                </Typography>
                <Divider variant="inset" component="div" sx={{margin: "10px 0px 10px 0px"}}></Divider>
                <table>
                    <tbody>
                    <tr>
                        <td><span style={firstColumnStyle}>Név:</span></td>
                        <td>{user.username}</td>
                    </tr>
                    <tr>
                        <td><span style={firstColumnStyle}>Email cím</span></td>
                        <td>{user.email}</td>
                    </tr>
                    <tr>
                        <td><span style={firstColumnStyle}>Szerepkör</span></td>
                        <td>{ROLES[user.role]}</td>
                    </tr>
                    <tr>
                        <td><span style={firstColumnStyle}>Csatlakozás dátuma</span></td>
                        <td>{parseDatetime(user.registrationDate)}</td>
                    </tr>
                    <tr>
                        <td><span style={firstColumnStyle}>Utolsó bejelentkezés</span></td>
                        <td>{parseDatetime(user.lastLogin)}</td>
                    </tr>
                    <tr>
                        <td><span style={firstColumnStyle}>Utolsó jelszóváltoztatás</span></td>
                        <td>{parseDatetime(user.lastPasswordChange)}</td>
                    </tr>
                    </tbody>
                </table>
                <div style={{textAlign: "right"}}>
                    <Button variant="contained" onClick={() => handleClickOpen()}>
                        Jelszó megváltoztatása
                    </Button>
                </div>
            </Paper>

            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData).entries());
                        updatePassword(formJson.oldPassword, formJson.newPassword, formJson.newPasswordDoubleCheck);
                    },
                }}
            >
                <DialogTitle sx={{background: "#1976d2", color: "white"}}>
                    Új jelszó beállítása
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        name="oldPassword"
                        label="Régi jelszó"
                        type="password"
                        fullWidth
                        variant="standard"
                        autoComplete="off"
                    />
                    <TextField
                        required
                        margin="dense"
                        name="newPassword"
                        label="Új jelszó"
                        type="password"
                        fullWidth
                        variant="standard"
                        autoComplete="off"
                    />
                    <TextField
                        required
                        margin="dense"
                        name="newPasswordDoubleCheck"
                        label="Új jelszó ismét"
                        type="password"
                        fullWidth
                        variant="standard"
                        autoComplete="off"
                    />
                    {errorMessage &&
                        <Alert severity="error" variant="standard" style={{color: "red", marginBottom: "8px"}}>
                            {errorMessage}
                        </Alert>}
                </DialogContent>
                <DialogActions>
                    {waitingForServer ? <CircularProgress sx={{marginLeft: "20px", marginRight: "auto"}}/> :
                        <Button type="submit" color="primary" variant="contained"
                                sx={{marginRight: "auto"}}>Mentés</Button>
                    }
                    <Button onClick={handleClose} color="error"
                            variant="outlined">Mégse</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default Profile

function parseDatetime(date) {
    return date.split(".")[0].replace("T", " ");
}